import { Grid, CircularProgress } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ToolTip from '../../components/Tooltip/Tooltip';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import BarChartVentas from './components/BarChartVentas';
import PieChartClasificacion from './components/PieChartClasificacion';
import YearGrowth from './components/YearGrowth';
import classes from './Ventas.module.css';

const Ventas = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, day].join('-');
		return dateFormat.toString();
	}

	const firstDateFilter = new Date();
	const date1 = formatDate(firstDateFilter.setMonth(firstDateFilter.getMonth() - 12));

	const secondDateFilter = new Date();
	const date2 = formatDate(secondDateFilter.setMonth(secondDateFilter.getMonth() - 1));

	//Filters
	const [country, setCountry] = useState('Todos');
	//const [moneda, setMoneda] = useState('CLP');
	const [clasificacion, setClasificacion] = useState(0);
	const [lineaNegocio, setLineaNegocio] = useState(0);
	const [idKam, setIdKam] = useState(0);
	const [initialDate, setInitialDate] = useState(date1);
	const [endDate, setEndDate] = useState(date2);

	//Apis
	const [ventasUrl, setVentasUrl] = useState(`/getVentas`);
	const [ventasYearUrl, setVentasYearUrl] = useState(`/getVentasAnualCompare?dateFrom=2019-12-31&dateTo=2018-12-01`);

	//Data
	const [ventas, setDataVentas] = useState([]);
	const [ventasYear, setVentasYear] = useState([]);

	//Aux
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	const [monthYear, setMonthYear] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			Axios.all([Axios.get(ventasUrl), Axios.get(ventasYearUrl)]).then(
				Axios.spread((obj1, obj2) => {
					try {
						setDataVentas(obj1.data);
						setVentasYear(obj2.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData();
	}, [ventasUrl, ventasYearUrl]);

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(endDate));
		}
	}, [isLoading, endDate]);

	return (
		<Fragment>
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								setVentasUrl(
									`/getVentas?dateFrom=${endDate}&dateTo=${initialDate}&pais=${country}&lineaNegocio=${lineaNegocio}&clasificacion=${clasificacion}&idKam=${idKam}`,
								);
								setVentasYearUrl(
									`/getVentasAnualCompare?dateFrom=${endDate}&dateTo=${initialDate}&pais=${country}&lineaNegocio=${lineaNegocio}&clasificacion=${clasificacion}&idKam=${idKam}`,
								);
								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={country} onChange={(event) => setCountry(event.target.value)}>
										<option value={'Todos'}>Todos los Países</option>
										<option value={'Chile'}>Chile</option>
										<option value={'Peru'}>Peru</option>
										<option value={'Argentina'}>Argentina</option>
									</select>
								</div>
								<div>
									<select value={idKam} onChange={(event) => setIdKam(event.target.value)}>
										<option value={'0'}>Todos los KAM</option>
										<option value={'11270'}>Damelis</option>
										<option value={'49772'}>Daniel</option>
										<option value={'29788'}>Milenna</option>
										<option value={'44530'}>Juana</option>
										<option value={'52724'}>Valeria</option>
										<option value={'44528'}>Francisco</option>
										<option value={'60760'}>Camila</option>
									</select>
								</div>

								<div>
									<select value={clasificacion} onChange={(event) => setClasificacion(event.target.value)}>
										<option value={'0'}>Pyme y Corp</option>
										<option value={'1'}>Pyme</option>
										<option value={'2'}>Corp</option>
									</select>
								</div>
								<div>
									<select value={lineaNegocio} onChange={(event) => setLineaNegocio(event.target.value)}>
										<option value={'0'}>Todas las Ventas</option>
										<option value={'1'}>Solo Recurrentes</option>
										<option value={'2'}>No Recurrentes</option>
									</select>
								</div>
								<div>
									<input type="date" id="dateDesde" value={initialDate} onChange={(event) => setInitialDate(event.target.value)} />
								</div>

								<div>
									<input type="date" id="dateHasta" defaultValue={endDate} onChange={(event) => setEndDate(event.target.value)} />
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.cardTitle}>{isLoading ? <div></div> : <div>Información a {monthYear}</div>}</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 2 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<ToolTip
								text={
									'Este gráfico muestra el movimiento de los ingresos entre las fechas seleccionadas, siempre y cuando existan registros'
								}
							/>
							<div className={classes.barChartVentas}>
								<BarChartVentas data={ventas} isLoading={isLoading} initialDate={initialDate} endDate={endDate} idKam={idKam} />
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* SECCIÓN 1 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip text={'Venta para el mes actual seleccionado comparado con un período anterior'} />
							<div className={classes.headerTitle}>Ventas Mes Actual</div>
							<YearGrowth data={ventasYear} isLoading={isLoading} endDate={endDate} initialDate={initialDate} />
						</div>
					</Grid>
					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip text={'Estos son los ingresos distribuidos por la clasificación de la empresa'} />
							<PieChartClasificacion data={ventasYear} isLoading={isLoading} />
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
	// return React.createElement('div', {className: 'App'}, React.createElement('h1', null, 'Does this work now?'));
};

export default React.memo(withErrorHandler(Ventas, Axios));
